import React, { useRef, useState } from 'react'
import Tooltip from '../Tooltip/Tooltip'
import { BadgeProps } from './Badge.types'

const Badge: React.FC<BadgeProps> = ({
    size = 'md',
    isOutline,
    isDiscreet,
    isFullWidth = false,
    isUppercase = false,
    type = 'default',
    tooltip = null,
    tooltipProps = {},
    children,
}) => {
    const [isMouseOver, setIsMouseOver] = useState(false)
    const ref = useRef(null)
    const classNames = () => {
        const c = ['r-badge-container', `r-size-${size}`]

        switch (type) {
            case 'default':
                c.push('r-type-default')
                break
            case 'success':
                c.push('r-type-success')
                break
            case 'warning':
                c.push('r-type-warning')
                break
            case 'primary':
                c.push('r-type-primary')
                break
            case 'danger':
                c.push('r-type-danger')
                break
        }

        if (isFullWidth) {
            c.push('r-full-width')
        }
        if (isUppercase) {
            c.push('r-uppercase')
        }
        if (isDiscreet) {
            c.push('r-state-discreet')
        } else if (isOutline) {
            c.push('r-state-outline')
        }

        return c.join(' ')
    }

    return (
        <div
            ref={ref}
            data-testid='Badge'
            className={classNames()}
            onMouseEnter={() => setIsMouseOver(true)}
            onMouseLeave={() => setIsMouseOver(false)}
        >
            {children}
            {tooltip && isMouseOver ? (
                <Tooltip {...tooltipProps} anchor={ref} show={true}>
                    {tooltip}
                </Tooltip>
            ) : null}
        </div>
    )
}

export default Badge
